export default {"src":"https://gfiber.com/support/_next/static/media/GF-0074-EMAIL US.a82292be.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};